import * as React from 'react';

export interface LinkContextProps {
  domainName: string;
  hashMatch: boolean;
}

export const LinkContext = React.createContext<Partial<LinkContextProps>>({});
